module.exports = __webpack_public_path__ + "img/feature-item-04.8e8c16ca.png";